// extracted by mini-css-extract-plugin
export default {"layout":"icons-page_layout__P6yD7"};